import { PersonHistoryFetch } from './History.type';
import axios from '../../../../services/axios.service';
import { getEndpointBase } from '../../../../services/api.service';
import { HISTORY_PER_PAGE } from '../History.constant';

let listRequest: any = null;

const PersonHistoryService = {
  getList(params: PersonHistoryFetch) {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(
      getEndpointBase(`people/${params.personId}/records/history`),
      {
        params: {
          records: params.records,
          page_size: params.perPage || HISTORY_PER_PAGE,
          page: params.page,
        },
        cancelToken: listRequest.token,
      },
    );
  },
};

export default PersonHistoryService;
